import { styled, Box } from '@mui/material';
import { routePath } from '~/utils/constants';

export const SIDEBAR_WIDTH = '214px';
export const TOP_NAV = '72px';
export const TOP_NAV_LOGIN_MOBILE = '48px';

export const StyledContent = styled(Box)(() => ({
  display: 'flex',
}));

type TStyledMain = {
  path: string;
  isSideBarShown: boolean;
  isOffline: boolean;
};

export const StyledMain = styled(Box, {
  shouldForwardProp: prop => {
    return prop !== 'path' && prop !== 'isSideBarShown' && prop !== 'isOffline';
  },
})<TStyledMain>(({ path, isSideBarShown, isOffline, theme }) => ({
  marginTop: isOffline ? `calc(${TOP_NAV} + 40px)` : TOP_NAV,
  width:
    path === routePath.resource && isSideBarShown && !isOffline
      ? `calc(100% - ${SIDEBAR_WIDTH})`
      : '100%',
  marginLeft:
    path === routePath.resource && isSideBarShown && !isOffline
      ? SIDEBAR_WIDTH
      : '0px',
  padding: isOffline
    ? '0px 16px'
    : path === routePath.login
      ? '40px 122px 0px'
      : '16px 16px 0px',
  overflow: 'hidden',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  gap: '16px',
  [theme.breakpoints.down('desktop')]: {
    width: '100%',
    marginLeft: '0px',
    gap: '14px',
    padding: path === routePath.login ? '16px 106.5px' : '32px 16px 60px 16px',
  },
  [theme.breakpoints.down('tablet')]: {
    padding: path === routePath.login ? '16px 24px' : '',
    marginTop: path === routePath.login ? TOP_NAV_LOGIN_MOBILE : '',
  },
}));
